import React, { useReducer, useEffect, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { getActiveEvents } from '../../apis/getActiveEvents';

import { AuthContext } from '../../reducers/Auth/AuthContext';
import { PlaceStoreContext } from '../../reducers/Place/PlaceContext';
import EventsReducer from './EventsReducer';
import { initialState } from './EventsInitialState';
import { getFeatures } from '../../utils/getFeatures';

export const EventsStoreContext = React.createContext(initialState);
export const EventsStore = ({ children }) => {
  const history = useHistory();
  const [state, dispatch] = useReducer(EventsReducer, initialState);
  const [authState] = useContext(AuthContext);
  const [placeState] = useContext(PlaceStoreContext);
  const { authenticated, user } = authState;
  const { placeId, userId } = user;
  const isAuthenticated = authenticated && placeId && userId;
  const [eventsInterval, setEventsInterval] = useState(null);

  const { hasLive } = getFeatures(placeState.place.features);

  useEffect(() => {
    if (isAuthenticated) {
      const placeIdFromPlaceState = placeState?.place?.id;
      if (placeIdFromPlaceState === placeId) {
        console.log('GETTING INITIAL EVENTS');
        getEvents();
      }
    } else {
      dispatch({ type: 'RESET', payload: {} });
    }
  }, [isAuthenticated, placeState]);

  useEffect(() => {
    if (!authState.placeId || !authState.userId) {
      return;
    }
    console.log('ERROR DETECTED EVENTS', state.error);
    if (state.error) {
      history.replace('/error');
    }
  }, [state, authState]);

  useEffect(() => {
    if (!isAuthenticated) {
      window.removeEventListener('refresh_places_and_events', getEvents);
      return;
    }

    const placeIdFromPlaceState = placeState?.place?.id;

    if (placeIdFromPlaceState) {
      window.removeEventListener('refresh_places_and_events', getEvents);
      window.addEventListener('refresh_places_and_events', getEvents);
    } else {
      window.removeEventListener('refresh_places_and_events', getEvents);
    }

    return () => {
      window.removeEventListener('refresh_places_and_events', getEvents);
    };
  }, [authState, placeState]);

  useEffect(() => {
    const placeIdFromPlaceState = placeState?.place?.id;
    if (placeIdFromPlaceState) {
      setEventsInterval(setInterval(getEvents, 120000));
    } else {
      clearInterval(eventsInterval);
      setEventsInterval(null);
    }
  }, [placeState]);

  const getEvents = async () => {
    if (!hasLive) return;
    
    try {
      const placeIdFromPlaceState = placeState?.place?.id;

      if (state.loading || !isAuthenticated || !placeIdFromPlaceState) {
        console.error('FAILED TO REFRESH EVENTS, PLACE NOT INITIALIZED');
        return;
      }

      const payload = await getActiveEvents(placeState);
      dispatch({ type: 'LOAD_EVENTS', payload });

      if (payload.error) {
        console.error('FAILED TO GET EVENTS', payload.error);
      } else {
        // console.log('CONNECTED, EVENTS REFRESHED', placeId);
      }
    } catch (error) {
      console.error('COULD NOT UPDATE EVENTS');
      console.error(error);
    }
  };

  return (
    <EventsStoreContext.Provider value={[state, dispatch, { getEvents }]}>
      {children}
    </EventsStoreContext.Provider>
  );
};

export default EventsStore;
